import useParamsHandler from "../../Utils/useParamsHandel"
import { useQuery } from "@tanstack/react-query"
import { queryKeys, QUERY_CONFIG } from "../../lib/react-query"
import { toolsApi } from "../../services/api"
import { useAuthStore } from "../../store/authStore"
import { useSearchParams } from "react-router-dom"

/**
 * Hook for fetching DNS data
 */
export function useDns() {
    const orgId = useAuthStore((state) => state.orgId)
    const { getParams } = useParamsHandler()
    const URLparams = getParams().params
    return useQuery({
        queryKey: queryKeys.dns.list(orgId),
        queryFn: () => toolsApi.getDns(URLparams),
        enabled: !!orgId,
    })
}

/**
 * Hook for fetching SMTP data with pagination support
 */
export function useSmtp(page: number = 1) {
    const orgId = useAuthStore((state) => state.orgId)
    const [searchParams] = useSearchParams()
    const params = searchParams.toString()
    return useQuery({
        queryKey: queryKeys.smtp.list(orgId, params),
        queryFn: () => toolsApi.getSmtp(params),
        enabled: !!orgId,
    })
}

/**
 * Hook for fetching services/features list
 * Automatically refetches when URL params change
 */
export function useServices() {
    const orgId = useAuthStore((state) => state.orgId)
    const { getParams } = useParamsHandler()
    const URLparams = getParams().params

    return useQuery({
        queryKey: queryKeys.services.list(orgId, URLparams),
        queryFn: () => toolsApi.getServices(URLparams),
        staleTime: QUERY_CONFIG.LISTS.staleTime,
        enabled: !!orgId,
    })
}